import {
  createContext,
  useState,
  useEffect,
  ReactNode,
  useCallback,
} from 'react';
import { userAxios } from 'APIs';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setSearchKeyword,
  clearSearchKeyword,
  setOffset,
} from '../partnerSlice';
import axios, { AxiosError } from 'axios';

interface Partners {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string;
  address: string | null;
  city: string | null;
  region: string | null;
  age: number | null;
  dateOfBirth: string | null;
  gender: string | null;
  zip: string | null;
  countryCode: string | null;
  designation: string | null;
  idProofNumber: string | null;
  currentWorkLocation: string | null;
  maritalStatus: string | null;
  totalExperience: number | null;
  role: string;
  status: number;
  idProofType: string | null;
}

interface partnersData {
  isLoading: boolean;
  status: number;
  error: boolean;
  data: Partners[];
  searchText: string;
}
interface PartnersContextProps {
  handleRowClick: (id: any) => void;
  partnersData: partnersData;
  loadMore: () => Promise<void>;
  handleSearchChange: (searchText: string) => void;
  handleClearSearch: () => void; // Added handleClearSearch
  searchKeyword?: string;
}
const PARTNER_DATA_MODAL = {
  isLoading: true,
  status: 0,
  error: false,
  data: [],
  searchText: '',
};

export const PartnersContext = createContext<PartnersContextProps | undefined>(
  undefined,
);

export const PartnersContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const dispatch = useDispatch();
  const { searchKeyword, offset, filters } = useSelector(
    (state: any) => state.partnerList,
  );
  console.log('mknkjnkj',searchKeyword)

  const navigate = useNavigate();
  const [partnersData, setPartnersData] =
    useState<partnersData>(PARTNER_DATA_MODAL);

  const hasFilterSelected =
    filters &&
    Object.keys(filters).some((key) => {
      const value = filters[key];
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== '' && value !== null && value !== undefined;
    });

  const getUrl = useCallback(() => {
    let url = `/chefs?offset=${offset}&limit=30`;

    if (searchKeyword && searchKeyword.length) {
      url += `&search=${searchKeyword}`;
    }

    if (hasFilterSelected) {
      url += `&filter=${JSON.stringify(filters)}`;
    }

    return url;
  }, [offset, searchKeyword, hasFilterSelected, filters]);

  const fetchData = useCallback(async () => {

    const url = getUrl();
    console.log("///url",url)

    try {
      const response = await userAxios.get(url);
      const {
        data: { error, data },
        status,
      } = response;

      setPartnersData((prev) => ({
        ...prev,
        isLoading: false,
        status,
        error,
        data: data.chefs,
        searchText: searchKeyword,
      }));
    } catch (err) {
      const status = (err as AxiosError)?.response?.status || 500;

      if (axios.isAxiosError(err) && status === 401) {
        localStorage.clear();
        navigate('/');
        return;
      }

      setPartnersData((prev) => ({
        ...prev,
        isLoading: false,
        status,
        error: true,
        data: [],
      }));
    }
  }, [navigate, getUrl, searchKeyword]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // if (!searchKeyword && !hasFilterSelected) {
    //   return;
    // }
    fetchData();
  }, [searchKeyword, hasFilterSelected, fetchData]);

  useEffect(() => {
    if (partnersData.data.length > offset) {
      dispatch(setOffset({ Offset: partnersData.data.length }));
    }
  }, [partnersData.data, offset, dispatch]);

  const loadMore = (): Promise<void> => {
    // simulate a request
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        actuallyLoadMore();
        resolve();
      }, 500);
    });
  };
  const actuallyLoadMore = () => {
    console.log('actuallyLoadMore Called!!');
  };

  const handleSearchChange = (searchTerm: string) => {
    dispatch(setSearchKeyword({ searchKeyword: searchTerm }));
  };

  const handleClearSearch = () => {
    dispatch(clearSearchKeyword());
  };

  //page navigation function//
  const handleRowClick = (id: any) => {
    console.log('click');
    navigate(`/app/partners/${id}/details`, {
      state: { heading: 'Partner details', iconClass: 'bi-chevron-left' },
    });
  };

  return (
    <PartnersContext.Provider
      value={{
        partnersData,
        loadMore,
        handleSearchChange,
        searchKeyword,
        handleClearSearch,
        handleRowClick,
        //,searchLogic, //fetchUsers
      }}
    >
      {children}
    </PartnersContext.Provider>
  );
};
